const docsAssetUrlMap = {
  '3d-animation':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442085/3D-animation.svg',
  avatar:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442129/avatar.png',
  avatar2:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442128/avatar2.png',
  'bouqs-audio':
    'https://res.cloudinary.com/magicsky/video/upload/v1737149079/bouqs-audio.m4a',
  'han-solo':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442070/hansolo.png',
  'clapping-hands':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442079/clapping-hands.svg',
  businessman:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442081/businessman.png',
  'hair-makeup':
    'https://res.cloudinary.com/magicsky/image/upload/s--Y8g32GsS--/f_auto,q_auto/hair-makeup',
  'darth-vader':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442077/darthvader.png',
  'hexclad-gordon':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442069/hexclad-gordon.png',
  'landscape-video':
    'https://res.cloudinary.com/magicsky/video/upload/v1740088759/landscape-video.mov',
  'leia-organa':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442068/leiaorgana.png',
  musician:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442065/musician.png',
  mountains:
    'https://res.cloudinary.com/magicsky/image/upload/s--d38kOCg2--/f_auto,q_auto/mountains',
  'obi-wan':
    'https://res.cloudinary.com/magicsky/image/upload/v1731442064/obiwan.png',
  'portrait-video':
    'https://res.cloudinary.com/magicsky/video/upload/v1740088760/portrait-video.mov',
  pug: 'https://res.cloudinary.com/magicsky/image/upload/v1731442062/pug.png',
  'qf-logo':
    'https://res.cloudinary.com/magicsky/image/upload/v1731448878/qf-logo.svg',
  skater:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442060/skater.png',
  videographer:
    'https://res.cloudinary.com/magicsky/image/upload/v1731442059/videographer.png',
  episode1:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292770/episode1poster.jpg',
  episode2:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292769/episode2poster.jpg',
  episode3:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292769/episode3poster.jpg',
  episode4:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292769/episode4poster.jpg',
  episode5:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292768/episode5poster.jpg',
  episode6:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292768/episode6poster.jpg',
  episode7:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292768/episode7poster.jpg',
  episode8:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292768/episode8poster.jpg',
  episode9:
    'https://res.cloudinary.com/magicsky/image/upload/v1744292768/episode9poster.jpg',
  episode4trailer:
    'https://res.cloudinary.com/magicsky/video/upload/v1744322502/episode4trailer.mp4',
  speeder:
    'https://res.cloudinary.com/magicsky/image/upload/v1744490708/speeder.jpg',
  r2d2: 'https://res.cloudinary.com/magicsky/image/upload/v1744490707/r2d2.jpg',
  'rebel-alliance':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490707/rebel-alliance-logo.jpg',
  'millennium-falcon':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490707/millennium-falcon.jpg',
  'jedi-temple':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490706/jedi-temple.jpg',
  'jedi-order':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490706/jedi-order-logo.jpg',
  jabba:
    'https://res.cloudinary.com/magicsky/image/upload/v1744490705/jabba.jpg',
  'galactic-empire':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490704/galactic-empire-logo.jpg',
  'galactic-republic':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490704/galactic-republic-logo.png',
  endor:
    'https://res.cloudinary.com/magicsky/image/upload/v1744490703/endor.jpg',
  'echo-base':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490702/echo-base.jpg',
  'death-star':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490701/death-star.jpg',
  'corellian-shipyard':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490701/corellian-shipyard.jpg',
  'clone-soldiers':
    'https://res.cloudinary.com/magicsky/image/upload/v1744490701/clones.jpg',
  chopper:
    'https://res.cloudinary.com/magicsky/image/upload/v1744490700/chopper.jpg',
  bb8: 'https://res.cloudinary.com/magicsky/image/upload/v1744490700/bb8.jpg',
}

export type DocsAssetName = keyof typeof docsAssetUrlMap

export const getDocsAssetUrl = (asset: DocsAssetName) => docsAssetUrlMap[asset]
